module.exports = __webpack_public_path__ + "img/26.80e66131.png";